import { eeEnvVariables } from '@/utilities/constants';
import { Configuration, LogLevel } from '@azure/msal-browser';

export const msalConfig: Configuration = {
  auth: {
    clientId: eeEnvVariables.AUTH_CLIENT_ID, // manifest → webApplicationInfo.id
    authority: `https://login.microsoftonline.com/${eeEnvVariables.TENANT_ID}`, // tenant
    redirectUri: window.location.origin + '/authend',
    navigateToLoginRequestUrl: false,
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      logLevel: LogLevel.Warning,
      piiLoggingEnabled: false,
    },
  },
};

export const loginRequest = {
  scopes: [`api://${eeEnvVariables.RESOURCE_URI}/${eeEnvVariables.AUTH_CLIENT_ID}/.default`],
};

export enum CustomLoginError {
  canceledByUser = 'CancelledByUser',
  executiveUserNotAllowed = 'ExecutiveUserIsNotAllowed',
  commonErrorMessage = 'CommonErrorMessage',
}
